/**
 * aC Men's Hub の FAQ 監視「対応方針」の共有定義。
 * API（apps/api/ac-mens-hub）と Web（apps/web/ac-mens-hub）が共有する。
 *
 * メモの上限を両側で独立に持つと、片方だけ広げたときに「画面では書けるのに保存で 400」
 * という壊れ方をする。値は1箇所に置き、両側から import する。
 *
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business Shares the FAQ disposition note limit between the API validation and the Web input so both sides cannot drift.
 * @graph-connects none
 */
/**
 * 対応方針メモの最大文字数。
 *
 * API の入力検証と、画面の入力欄の maxLength が同じ値を指す必要がある。
 *
 * @graph-node {Variable}
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business Caps the length of a FAQ disposition note shared by the API validation and the Web input.
 * @graph-connects none
 */
export const FAQ_DISPOSITION_NOTE_MAX_LENGTH = 1000;
//# sourceMappingURL=faq-disposition.js.map